import dashboard from './dashboard';
import workout from './workout';
import multiVideoWorkout from './multiVideoWorkout';
import profile from './profile';
import feedback from './feedback';
import endworkout from './endworkout';
import trainerProfile from './trainerProfile'
import userProfile from './userProfile'
import aboutUs from './aboutUs'
import b2b from './b2b'
import Vue from "vue"

const state = {
};

const mutations = {
    notify(state, message) {
        Vue.$log.info(message)
    },
};

const getters = {

};

const actions = {

};


export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
    modules: {
        dashboard,
        workout,
        multiVideoWorkout,
        profile,
        feedback,
        endworkout,
        trainerProfile,
        userProfile,
        aboutUs,
        b2b
    }
}
